module.exports = __webpack_public_path__ + "static/media/html.7b1c5ffe.svg";